module.exports = __webpack_public_path__ + "img/join-member-th.f193b405.png";